export default __webpack_public_path__ + "static/media/book1.52cb0efa.jpg";